import {Navigate} from "react-router-dom";
import React, {FormEvent, ReactElement} from "react";
import {authActions, authSelectors} from "./authSlice";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {FormGroup} from "components/UIComponents/FormGroup";
import {FormattedMessage} from "react-intl";
import {isEmpty, trim} from "ramda";
import {CoverMoodForm} from "../../components/UIComponents/cover-mood-form/CoverMoodForm";
import {PageTitle} from "../../components/UIComponents/PageTitle";
import {FormInput} from "../../components/UIComponents/FormInput";
import {PrimaryButtonBig} from "../../components/UIComponents/PrimaryButtonBig";
import {choseCustomerActions, choseCustomerSelectors} from "./choseCustomerSlice";

export interface ChoseCustomerPageProps {

}

export function ChoseCustomerPage(props: ChoseCustomerPageProps): ReactElement {
    const dispatch = useAppDispatch();
    const authedCustomer = useAppSelector(authSelectors.customer);

    const to = useAppSelector(choseCustomerSelectors.to);
    const customerInputValue = useAppSelector(choseCustomerSelectors.customer);
    const setCustomerInputValue = (customer: string) => dispatch(choseCustomerActions.setCustomer(customer));

    if (authedCustomer != null) {
        return <Navigate to={to}/>
    }

    const customerFormEmpty = customerInputValue == null || isEmpty(trim(customerInputValue));

    const setAuthedCustomer = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (customerFormEmpty) {
            console.error("customer is null or empty");
            return;
        }

        dispatch(choseCustomerActions.reset());
        dispatch(authActions.setCustomer(customerInputValue));
    };

    return (
        <CoverMoodForm>
            <form className="flex flex-col h-full" onSubmit={setAuthedCustomer}>
                <div className="flex-auto flex flex-col gap-6 justify-center">
                    <PageTitle>Login</PageTitle>

                    <div>
                        <FormGroup groupTitle={<span className="text-base"><FormattedMessage id="choseCustomer.customerNo"/></span>}>
                            <FormInput
                                autoFocus
                                value={customerInputValue}
                                onChange={e => setCustomerInputValue(e.target.value)}
                            />
                        </FormGroup>
                    </div>
                </div>

                <div className="flex-none">
                    <PrimaryButtonBig
                        type="submit"
                        disabled={customerFormEmpty}>
                        <FormattedMessage id="choseCustomer.submit"/>
                    </PrimaryButtonBig>
                </div>
            </form>

        </CoverMoodForm>
    );
}
